// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productMiniCardStyles } from "@rpsc/App/Components/Product/ProductMiniCard";
import productDescriptionVariantStyles from "@rpsc/App/SharedStyles/ProductDescriptionStyles";
import { color, ellipsis, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

productMiniCardStyles.productGridContainerStyles = {
    info: {
        css: css`
            flex-basis: 100%;
        `,
    },
    priceAndActions: {
        css: css`
            height: auto;
        `,
    },
};
productMiniCardStyles.imageAndDescriptionSection = {
    css: css`
        display: flex;
        gap: 12px;
        height: 100%;
    `,
};
productMiniCardStyles.descriptionContainerStyles = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
productMiniCardStyles.productImage = {
    linkWrappingImage: {
        css: css`
            width: 91px;
            height: 91px;
            align-items: flex-start;
            border: 1px solid ${color("common.border")};
            border-radius: 2px;
            overflow: hidden;
        `,
    },
};
productMiniCardStyles.productDescription = {
    productDetailDescription: {
        ...productDescriptionVariantStyles?.medium?.productDetailDescription,
        css: css`
            min-height: 38px;
        `,
    },
    productDetailLink: {
        ...productDescriptionVariantStyles?.medium?.productDetailLink,
        css: css`
            min-height: 38px;
            align-items: flex-start;
        `,
    },
};

productMiniCardStyles.productPriceAndActionsTopSectionStyles = {
    productGridContainer: {
        container: {
            css: css`
                max-width: initial;
                height: auto;
                &.authenticated .product-availability {
                    min-height: 32px;
                    ${xScreen("lte", "sm")} {
                        min-height: unset;
                    }
                }
            `,
        },
    },
    productAvailabilityStyles: {
        container: {
            gap: 0,
            offsetCss: css`
                display: flex;
                flex-direction: column;
                gap: 4px;
            `,
            css: css`
                min-height: 16px;
                margin-bottom: 8px;
                ${xScreen("lte", "sm")} {
                    min-height: unset;
                }
            `,
        },
        errorWrapper: {
            css: css`
                margin-bottom: 8px;
            `,
        },
        messageText: {
            css: css`
                ${ellipsis(1)}
            `,
        },
    },
    productPriceStyles: {
        wrapper: {
            css: css`
                margin-bottom: 4px;
            `,
        },
    },
};

productMiniCardStyles.productPriceAndActionsStyles = {
    productGridContainer: {
        container: {
            css: css`
                height: auto;
                max-width: initial;
            `,
        },
    },
    bottomSectionContainer: {
        css: css`
            margin-top: 0;
        `,
    },
    productActionsStyles: {
        addToCartButtonWrapper: {
            css: css`
                width: 100%;
            `,
        },
    },
    productAddToListStyles: {
        link: {
            css: css`
                margin-left: auto;
            `,
        },
    },
};
productMiniCardStyles.productPartNumbersStyles = {
    container: {
        css: css`
            margin-bottom: 8px;
        `,
    },
};
productMiniCardStyles.productBrand = {
    nameLink: {
        css: css`
            margin-top: 8px;
        `,
    },
    nameText: {
        css: css`
            margin-top: 8px;
        `,
    },
};
